// extracted by mini-css-extract-plugin
module.exports = {"twoCol":"BecomeAnAffiliate_twoCol__30Vo6","contentHolder":"BecomeAnAffiliate_contentHolder__dMqoV"};